import React from "react";
import { Stack, Grid, Typography, Box } from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";

import FormSelectField from "../components/common/FormSelectField";
import FormTextField from "../components/common/FormTextField";
import SubmitButton from "../components/buttons/SubmitButton";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

import { upgradeLicense } from "../redux/actions/licenseActions";
import { cleanFormData } from "../helpers/formHelpers";

const schema = Yup.object({
  newLicenseType: Yup.string().required("New license type is required"),
  expiryDate: Yup.date()
    .nullable()
    .min(new Date(), "Expiry date must be in the future"),
});

const UpgradeLicenseForm = ({ license, loading }) => {
  const dispatch = useDispatch();

  const typeOpts = [
    { value: "TRIAL", label: "Trial" },
    { value: "MONTHLY", label: "Monthly" },
    { value: "ANNUAL", label: "Annual" },
  ];

  return (
    <Formik
      initialValues={{ newLicenseType: "", expiryDate: "" }}
      validationSchema={schema}
      onSubmit={(values) =>
        dispatch(upgradeLicense(license.id, cleanFormData(values)))
      }
    >
      {({ isValid }) => (
        <Form>
          <Stack spacing={2}>
            <Box
              p={2}
              bgcolor="background.default"
              borderRadius={1}
              border="1px solid"
              borderColor="divider"
            >
              <Typography variant="body2" color="text.secondary">
                Current Type:
              </Typography>
              <Typography variant="body1" fontWeight="bold">
                {license.type}
              </Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormSelectField
                  name="newLicenseType"
                  label="Upgrade To"
                  options={typeOpts}
                />
              </Grid>
              <Grid item xs={12}>
                <FormTextField
                  name="expiryDate"
                  label="Custom Expiry Date (Optional)"
                  type="datetime-local"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
            <SubmitButton
              title="Upgrade License"
              loading={loading}
              disabled={!isValid || loading}
              startIcon={<TrendingUpIcon />}
            />
          </Stack>
        </Form>
      )}
    </Formik>
  );
};
export default UpgradeLicenseForm;
